export default __webpack_public_path__ + "static/media/flag-24px.05027088.svg";